import React from 'react'
import { massCheck, copyAttempt } from '../timesheetUtils'
import { baseUrl } from '../../assets/Animations'
import { format, eachDayOfInterval, startOfWeek, endOfWeek, endOfMonth, parse, subMonths } from 'date-fns'
import axios from 'axios'
import { createAndOrganizeAllCalendarEventsForDisplayedPeriodOfTime, createAndOrganizeTeachersCalendarEventsForDisplayedPeriodOfTime } from '../../Calendar/calendarFunctions'

const myToken = localStorage.getItem('token')
const myHeader = {headers: { Authorization: `Bearer ${myToken}` }}

const InvoicesTab = ({schoolList, invoices, setInvoices, schoolTab, teachers, setOpenInvoice, timesheets}) => {
    const [calendarEvents, setCalendarEvents] = React.useState([])
    const [lastMonthsCalendarEvents, setLastMonthsCalendarEvents] = React.useState([])
    //get each day interval for the last month
    let lastMonth = format(subMonths(new Date(), 1), 'MMM yyyy')
    let firstDayOfLastMonth = parse(lastMonth, 'MMMM yyyy', new Date())
    let daysOfLastMonth = eachDayOfInterval({start: startOfWeek(parse(lastMonth, 'MMMM yyyy', new Date())), end: endOfWeek(endOfMonth(parse(lastMonth, 'MMMM yyyy', new Date())))})


    React.useEffect(() => {
        axios.get(`${baseUrl}/calendar`, myHeader)
        .then((res) => setCalendarEvents(res.data))
        .catch((err) => console.log(err))
    }, [])

    React.useEffect(() => {
        calendarEvents.length > 0 && createAndOrganizeTeachersCalendarEventsForDisplayedPeriodOfTime(daysOfLastMonth, calendarEvents, setLastMonthsCalendarEvents)
    }, [calendarEvents])

    const turnTeacherIDintoTeacherName = (id, teachers) => {
        for(let i = 0; i < teachers.length; i++) {
            if(teachers[i].TeacherID === id) {
                return teachers[i].Name
            }
        }
        //teachers.find((teach) => teach.TeacherID === id).Name 
    }

    const badFunctionToRemoveDuplicates = (invoice) => {
        let seen = {}
        let arrayOfT = []
        Object.keys(lastMonthsCalendarEvents).forEach((key) => {
            if(lastMonthsCalendarEvents[key].events) {
                for(let i = 0; i < lastMonthsCalendarEvents[key].events.length; i++) {
                    if(lastMonthsCalendarEvents[key].events[i].familyId === invoice.familyId) {
                        if(!seen[lastMonthsCalendarEvents[key].events[i].teacherId]) {
                            let teacherObj = {
                                teacherName: lastMonthsCalendarEvents[key].events[i].teacherName,
                                submittedTimesheet: checkIfTeacherHasSubmittedThisMonthsTimesheet(lastMonthsCalendarEvents[key].events[i].teacherId)
                            }
                            seen[lastMonthsCalendarEvents[key].events[i].teacherId] = true
                            arrayOfT.push(teacherObj)
                        }
                    }
                }
            }
        })
        //filter out duplicates
        arrayOfT = arrayOfT.filter((item, index) => arrayOfT.indexOf(item) === index)
        return arrayOfT
    }

    const checkIfTeacherHasSubmittedThisMonthsTimesheet = (teacherId) => {
        for(let i = 0; i < timesheets.length; i++) {
            if(timesheets[i].teacherId === teacherId) {
                return true
            }
        }
        return false
    }

    const openTheInvoiceAndGetFamilyInfo = (invoice, shouldItDelete) => {
        console.log(invoice)
        let invoiceWithFamilyInfo = invoice
        if(shouldItDelete) {
            axios.delete(`${baseUrl}/invoice/${invoice.invoiceId}`)
            .then((res) => setInvoices(invoices.filter(item => item.invoiceId !== res.data.invoiceId)))
            .catch((err) => console.log(err))
        } else {
            if(invoice.waveCustomerId){
                axios.get(`${baseUrl}/family-lookup/${invoice.waveCustomerId}`, myHeader)
                .then((res) => {
                    invoiceWithFamilyInfo.familyInfo = res.data
                    setOpenInvoice(invoiceWithFamilyInfo)
                })
                .catch((err) => {
                    console.log(err)
                })
            } else {
                axios.get(`${baseUrl}/school-management/${invoice.familyId}`, myHeader)
                .then((res) => {
                    console.log(res.data)
                    invoiceWithFamilyInfo.familyInfo = res.data
                    invoiceWithFamilyInfo.waveCustomerId = res.data.waveCustomerId
                    setOpenInvoice(invoiceWithFamilyInfo)
                })
                .catch((err) => {
                    console.log(err)
                })
            }
        }
    }

    const againFindStudentRate = (theLesson, theInvoice, nameOnInvoice, lengthOfLesson) => {
        let found = false
        if(parseInt(lengthOfLesson) === 31 || parseInt(lengthOfLesson) === 46 || parseInt(lengthOfLesson) === 61) {
          found = true
          if(parseInt(lengthOfLesson) === 31) {
            return 25
          } else if (parseInt(lengthOfLesson) === 46) {
            return 35
          } else if (parseInt(lengthOfLesson) === 61) {
            return 45
          }
        } else {
            if(theLesson.studentAllRates) {
                return theLesson.studentAllRates[parseInt(lengthOfLesson)]
            } else {
                //-----------THIS IS GOING OFF OF WHAT THE STUDENTS RATE WAS BASED OFF OF REAL TIME DATABASE RATE
                if(theInvoice.familyInfo) {
                    for(let i = 0; i < theInvoice.familyInfo.students.length; i++) {
                        if(theInvoice.familyInfo.students[i].studentName === nameOnInvoice) {
                            found = true
                            if(!theInvoice.familyInfo.students[i].allRates) {
                              return theInvoice.familyInfo.students[i].lessonRate
                            } else {
                              return theInvoice.familyInfo.students[i].allRates[lengthOfLesson]
                            }
                        }
                    }
                }
            }
        }
        if(!found) {
            //alert('Student does not exist in the database. Either change student name or go to Student Database and add student to family.')
            return 0
        }  
    }

    const estimateCharge = (theInvoice) => {
        let total = 0
        for(let i = 0; i < theInvoice.lessonsToBeBilled.length; i++) {
            total = Math.floor(parseInt(total) + parseInt(againFindStudentRate(theInvoice.lessonsToBeBilled[i], theInvoice, theInvoice.lessonsToBeBilled[i].studentName, theInvoice.lessonsToBeBilled[i].lessonLength)))
        }
        for(let i = 0; i < theInvoice.extrasToBeBilled.length; i++) {
          total = Math.floor(parseInt(total) + parseInt(theInvoice.extrasToBeBilled[i].amount))
        }
        return total
    }

    return(
        <div>
        {schoolList.map((school, index) => (
        <div className="whole-invoice-wrapper" key={index}>
            {school === schoolTab &&
                <div>
                    <div className="timesheet-school-name__title">
                        <div className="student-db-btn-wrapper">
                            <div className="add-email-btn on-timesheet" onClick={() => copyAttempt()}>Copy Emails</div>
                        </div>
                    </div>
                    <table className="student-table">
                        <thead>
                            <tr>
                                <th><input onClick={(e) => massCheck(e.target.checked)} style={{border: '1px solid black'}} type="checkbox" /></th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Invoice Status</th>
                                <th>Total</th>
                                <th>Teachers</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoices.map(invoice => (
                                invoice.school === school &&
                                <tr key={invoice.invoiceId} className="each-row">
                                    <td><input className={"student-checkbox"} type="checkbox" style={{border: '1px solid black'}} value={invoice.email}/></td>
                                    <td onClick={() => openTheInvoiceAndGetFamilyInfo(invoice, false)} >{invoice.familyName}</td>
                                    <td onClick={() => openTheInvoiceAndGetFamilyInfo(invoice, false)} >{invoice.email}</td>
                                    {
                                        (() => {
                                            switch(invoice.status) {
                                                case 'In Wave':
                                                    return <td onClick={() => openTheInvoiceAndGetFamilyInfo(invoice, false)}><p className="status-in-wave">{invoice.status}</p></td>
                                                case 'Scholarship':
                                                    return <td onClick={() => openTheInvoiceAndGetFamilyInfo(invoice, false)}><p className="status-scholarship">{invoice.status}</p></td>
                                                default:
                                                    return <td onClick={() => openTheInvoiceAndGetFamilyInfo(invoice, false)}><p className="status-submitted">{invoice.status}</p></td>
                                            }
                                        })()
                                    }
                                    <td onClick={() => openTheInvoiceAndGetFamilyInfo(invoice, false)} >${estimateCharge(invoice)}</td>
                                    <td onClick={() => openTheInvoiceAndGetFamilyInfo(invoice, false)} >{badFunctionToRemoveDuplicates(invoice).map(teacher => <div key={teacher.teachersId}>{teacher.submittedTimesheet ? <p>{teacher.teacherName}</p> : <p style={{color: "red"}}>{teacher.teacherName}</p>}</div>)}</td>
                                    <td className="delete-this-invoice" onClick={() => openTheInvoiceAndGetFamilyInfo(invoice, true)}>Delete</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            }
        </div>
    ))}
</div>  
    )
}
export default InvoicesTab